import React from "react";
import CompensatedTable from "./CompensatedTable/index";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, makeStyles } from "@material-ui/core";
import { handleOpenIncidentFormDialog, showAlertSnackbar } from '../../../reducers/uiSlice';
import moment from 'moment';
import DateRangePicker from "../../Common/DateTimeRangePicker";
import { getPartnerList } from "../../../actions/mmActions";
import _ from "lodash";
import { getBranchList } from '../../../actions/commonAction'
import {
    searchCompensated
} from "../../../actions/incidentManagementActions";
import { Autocomplete } from "@material-ui/lab";
import update from 'immutability-helper';

const useStyles = makeStyles((theme) => ({
    grid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(1.5),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    firstgrid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2)
    },
    quickActionButton: {
        whiteSpace: 'nowrap',
        minWidth: 'auto',
    },
    textField: {
        width: '100%',
    },
    Button: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'right',
        marginRight: theme.spacing(-7),
    },
    rowItem: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(3)
    },
}));

// ... (previous imports and styles)

function IncidentCompensated() {
    const { t } = useTranslation('incidentManagement');
    const branchList = useSelector(state => state.common.branches);
    const userList = useSelector(state => state.common.users);
    const statusList = useSelector(state => state.incidentManagement.statusList);
    const [partners, setPartners] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const dispatch = useDispatch();
    const classes = useStyles();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [detailedDate, setDetailedDate] = useState([]);
    const [timezone, setTimezone] = useState('');

    const [dateRange, setDateRange] = useState({
        from: moment().startOf('day'),
        to: moment().endOf('day')
    });

    const [selectedWarehouse, setSelectedWarehouse] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const quickDateActionList = [
        {
            id: 1,
            label: t('last_month'),
            change_by: [
                {
                    type: 'subtract',
                    date_type: 'months',
                    value: 1
                }
            ]
        },
        {
            id: 2,
            label: t('last_two_month'),
            change_by: [
                {
                    type: 'subtract',
                    date_type: 'months',
                    value: 2
                }
            ]
        }
    ]

    const handleWarehouseChange = (event, newValue) => {
        setSelectedWarehouse(newValue);
    };

    const handleDateChange = (event) => {
        let newValue = update(dateRange, {
            [event.target.id]: {
                $set: event.target.id === "from" ?
                    moment(event.target.value).startOf('day')
                    :
                    moment(event.target.value).endOf('day')
            }
        });
        setDateRange(newValue)
    }

    const handleQuickDateAction = (actionItem) => {
        let newDate = moment()
        _.forEach(actionItem.change_by, (changeBy) => {
            newDate[changeBy.type](changeBy.value, changeBy.date_type)
        })
        let newState = update(dateRange, { from: { $set: newDate.endOf('day') } });
        setDateRange(newState)
    }
    useEffect(() => {
        dispatch(getPartnerList()).then((res) => {
            setPartnerList(res);
        })
    }, []);

    const handleSearch = () => {
        setIsDataLoading(true);
        const fromDateTimestamp = Math.floor(new Date(dateRange.from).getTime() / 1000);
        const toDateTimestamp = Math.floor(new Date(dateRange.to).getTime() / 1000);

        const params = {
            from_date: fromDateTimestamp,
            to_date: toDateTimestamp,
        };

        if (!_.isNil(partners) && partners !== "") {
            params.partner_ids = partners;
        }

        if (!_.isNil(selectedWarehouse)) {
            params.warehouse = selectedWarehouse.map(warehouse => warehouse.id);
        }

        dispatch(searchCompensated(params))
            .then((response) => {
                setDetailedDate(response);
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_success'),
                    type: 'success'
                }));
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('incident_management'),
                    message: t('search_failed'),
                    type: 'error'
                }));
                setDetailedDate([]);  // Clear the table data
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    };

    useEffect(() => {
        dispatch(getBranchList()).then((warehouses) => {
            setWarehouses(warehouses);
        });
    }, []);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={3} className={classes.firstgrid}>
                    <DateRangePicker
                        className={classes.dateRangeRow}
                        fromDateValue={dateRange.from}
                        toDateValue={dateRange.to}
                        textFieldStyle={{
                            minWidth: 130,
                            flex: 1
                        }}
                        handleDateChange={handleDateChange}
                    />
                </Grid>
                <Grid item xs={2.8} className={classes.grid}>
                    <div className={classes.rowItem}>
                        {quickDateActionList.map(item => (
                            <Button
                                className={classes.quickActionButton}
                                id={`date-quick-select-${item.id}`}
                                key={`date-quick-select-${item.id}`}
                                variant="contained"
                                onClick={() => handleQuickDateAction(item)}
                                color="secondary"
                                fullWidth
                            >
                                {t(item.label)}
                            </Button>
                        ))}
                    </div>
                </Grid>
                <Grid item xs={2} className={classes.grid}>
                    <Autocomplete
                        multiple
                        options={warehouses}
                        getOptionLabel={(option) => option.name}
                        value={selectedWarehouse}
                        onChange={handleWarehouseChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={t('warehouse')}
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={3} className={classes.grid}>
                    <Autocomplete
                        className={classes.textField}
                        options={partnerList}
                        getOptionLabel={(option) => option?.name}
                        limitTags={4} // 
                        multiple // 
                        onChange={(event, value) => {
                            setPartners(value.map((item) => item.id)); // 
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label={t("partners")} variant="outlined" />
                        )}
                        id="incident_compensated_order_autocomplete"
                        value={partnerList.filter((option) => partners.includes(option.id))} // 
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs={0.5} className={classes.grid}>
                    <Button
                        className={classes.Search}
                        id='button-search'
                        variant="contained"
                        color="secondary"
                        onClick={() => handleSearch()}
                    >
                        {t('common:search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <CompensatedTable
                        openIncidentForm={(params) => dispatch(handleOpenIncidentFormDialog(params))}
                        branchList={branchList}
                        statusList={statusList}
                        userList={userList}
                        data={detailedDate}
                        isDataLoading={isDataLoading}
                        timezone={timezone}
                    />
                </Grid>
            </Grid>

        </>
    );
}

export default IncidentCompensated;
